import { Employer } from './../models/Employer';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-employees',
  templateUrl: './employees.component.html'
})
export class EmployeesComponent implements OnInit {
  @Input() Employees: Employer[];
  @Output() EmployeesChange = new EventEmitter<Employer[]>();
  @Input() isModifyDisabled: boolean = false;
  selezionato: Employer;
  constructor(private toastService: ToastrService,
    ) { }

  ngOnInit() {
  }
  add() {
    this.Employees.push({
      nome: "",
      cognome: "",
      ruolo: "",
      modifica: true,
    })
    this.EmployeesChange.emit(this.Employees);
  }
  edit(item: Employer) {
    this.selezionato = item;
      if(item.modifica ){
        if (item.nome != " " && item.nome != "" && item.nome != null){
          item.modifica = !item.modifica;
          const idx: number = this.Employees.findIndex(x => x == item)
          // this.Employees[idx].nome = parseInt(item.um[0].id);
          this.EmployeesChange.emit(this.Employees);
        }
        else if (item.nome)
          this.toastService.warning("inserire un nome", "Attenzione!!");
        else
          this.toastService.warning("inserire un ruolo", "Attenzione!!");
      }else {
        item.modifica = !item.modifica;
      }
   }
  delete(item: Employer) {
    const idx: number = this.Employees.findIndex(x => x == item);
    if ( idx > -1) {
      this.Employees.splice(idx, 1);
      this.EmployeesChange.emit(this.Employees);
    }
  }

}
